// Kişisel Asistan — ses kaydı, ses çalma ve tarayıcı bildirimi yardımcıları (2026-09-18).
//
// Ekran %99 telefonda kullanılacak (kullanıcı notu); buradaki her şey mobil tarayıcıların
// kısıtlarına göre yazıldı:
//   - iPhone Safari, kullanıcı dokunuşu dışında başlatılan sesi çalmaz. Tek bir <audio>
//     nesnesi ilk dokunuşta "kilidi açılarak" hazırlanır; sonraki bütün sesler (sunucudan
//     gecikmeli gelenler dahil) aynı nesneyle çalınır.
//   - Kayıt biçimi tarayıcıya göre değişir (Chrome/Android: webm, iPhone: mp4). ElevenLabs
//     ikisini de kabul ediyor, dönüştürme yok.
//   - Konuşma bitince kayıt KENDİLİĞİNDEN durur (sessizlik algılama); telesekretere cevap
//     verirken ekrana dokunmak gerekmesin.

// ---------- Ses çalma ----------

// 0,1 saniyelik sessiz wav — yalnızca iPhone'da ses nesnesinin kilidini açmak için.
const SESSIZ =
  'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAIA+AAACABAAZGF0YQAAAAA=';

let calar = null;
let sonUrl = null;

function calici() {
  if (!calar) {
    calar = new Audio();
    calar.preload = 'auto';
  }
  return calar;
}

// Bip için tek bir AudioContext; o da iPhone'da ancak dokunuşla açılabiliyor.
let bipBaglami = null;

// Kullanıcının dokunduğu olayın İÇİNDE çağrılmalı (onClick'in ilk satırı).
export function sesKilidiniAc() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (Ctx) {
    if (!bipBaglami) bipBaglami = new Ctx();
    if (bipBaglami.state === 'suspended') bipBaglami.resume().catch(() => {});
  }
  const a = calici();
  if (a.dataset.acik) return;
  a.src = SESSIZ;
  a.play().then(() => { a.dataset.acik = '1'; }).catch(() => {});
}

// Telesekreterdeki "bip" — dosya değil, telefonda üretilir (kullanıcı talebi: 2026-09-18).
export function bip(sureMs = 380, frekans = 1000) {
  return new Promise((coz) => {
    const b = bipBaglami;
    if (!b) { coz(); return; }
    const osc = b.createOscillator();
    const kazanc = b.createGain();
    osc.type = 'sine';
    osc.frequency.value = frekans;
    const t = b.currentTime;
    // Yumuşak giriş/çıkış: ani başlayan sinüs "tık" sesi yapar.
    kazanc.gain.setValueAtTime(0, t);
    kazanc.gain.linearRampToValueAtTime(0.35, t + 0.02);
    kazanc.gain.setValueAtTime(0.35, t + sureMs / 1000 - 0.04);
    kazanc.gain.linearRampToValueAtTime(0, t + sureMs / 1000);
    osc.connect(kazanc).connect(b.destination);
    osc.start(t);
    osc.stop(t + sureMs / 1000);
    osc.onended = () => coz();
  });
}

// Sekreterin sabit cümleleri — oturum boyunca bellekte tutulur, her seferinde indirilmez.
const sabitOnbellek = new Map();

export async function sabitSesCal(anahtar, getir) {
  let blob = sabitOnbellek.get(anahtar);
  if (!blob) {
    blob = (await getir(anahtar)).data;
    sabitOnbellek.set(anahtar, blob);
  }
  return sesCal(blob);
}

// Blob ya da base64 mp3 çalar; bitince çözülen bir söz döner.
export function sesCal(kaynak) {
  const a = calici();
  a.pause();
  if (sonUrl) { URL.revokeObjectURL(sonUrl); sonUrl = null; }

  if (typeof kaynak === 'string') {
    a.src = `data:audio/mpeg;base64,${kaynak}`;
  } else {
    sonUrl = URL.createObjectURL(kaynak);
    a.src = sonUrl;
  }

  return new Promise((coz, reddet) => {
    a.onended = () => coz();
    a.onerror = () => reddet(new Error('Ses çalınamadı.'));
    a.play().catch(reddet);
  });
}

export function sesiDurdur() {
  if (calar) calar.pause();
}

// ---------- Ses kaydı ----------

function kayitTuru() {
  const adaylar = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus'];
  if (typeof MediaRecorder === 'undefined') return '';
  return adaylar.find(t => MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(t)) || '';
}

export const kayitDestekleniyor = () =>
  typeof window !== 'undefined' && !!navigator.mediaDevices?.getUserMedia && typeof MediaRecorder !== 'undefined';

// Kayıt başlatır. Seçenekler:
//   sessizlikMs   konuşma başladıktan sonra bu kadar sessizlik olursa kayıt biter
//   baslamazsaMs  hiç konuşulmazsa bu süre sonunda biter (boş kayıt döner)
//   azamiMs       en uzun kayıt süresi
//   seviye(v)     0..1 ses seviyesi (ekrandaki halka animasyonu için)
// Dönen nesne: { bitti: Promise<{ blob, dosyaAdi, konusuldu }>, durdur() }
export async function kayitBaslat({ sessizlikMs = 1800, baslamazsaMs = 8000, azamiMs = 60000, seviye } = {}) {
  const akis = await navigator.mediaDevices.getUserMedia({
    audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
  });

  const tur = kayitTuru();
  const kaydedici = new MediaRecorder(akis, tur ? { mimeType: tur } : undefined);
  const parcalar = [];
  kaydedici.ondataavailable = (e) => { if (e.data && e.data.size) parcalar.push(e.data); };

  // Sessizlik algılama: ses seviyesi eşiği aşınca "konuşuluyor", eşiğin altında kalınca sayaç.
  const Ctx = window.AudioContext || window.webkitAudioContext;
  const baglam = Ctx ? new Ctx() : null;
  let analiz = null;
  if (baglam) {
    const kaynak = baglam.createMediaStreamSource(akis);
    analiz = baglam.createAnalyser();
    analiz.fftSize = 1024;
    kaynak.connect(analiz);
  }

  const ESIK = 0.035;
  let konusuldu = false;
  let sonSes = performance.now();
  const baslangic = performance.now();
  let dongu = null;
  let bitirildi = false;

  const durdur = () => {
    if (bitirildi) return;
    bitirildi = true;
    if (dongu) cancelAnimationFrame(dongu);
    if (kaydedici.state !== 'inactive') kaydedici.stop();
  };

  const bitti = new Promise((coz) => {
    kaydedici.onstop = () => {
      akis.getTracks().forEach(t => t.stop());
      if (baglam) baglam.close().catch(() => {});
      const tip = kaydedici.mimeType || tur || 'audio/webm';
      const uzanti = tip.includes('mp4') ? 'm4a' : tip.includes('ogg') ? 'ogg' : 'webm';
      coz({ blob: new Blob(parcalar, { type: tip }), dosyaAdi: `kayit.${uzanti}`, konusuldu });
    };
  });

  if (analiz) {
    const veri = new Float32Array(analiz.fftSize);
    const olc = () => {
      analiz.getFloatTimeDomainData(veri);
      let t = 0;
      for (let i = 0; i < veri.length; i++) t += veri[i] * veri[i];
      const rms = Math.sqrt(t / veri.length);
      const simdi = performance.now();
      if (seviye) seviye(Math.min(1, rms * 8));

      if (rms > ESIK) { konusuldu = true; sonSes = simdi; }
      if (konusuldu && simdi - sonSes > sessizlikMs) return durdur();
      if (!konusuldu && simdi - baslangic > baslamazsaMs) return durdur();
      if (simdi - baslangic > azamiMs) return durdur();
      dongu = requestAnimationFrame(olc);
    };
    dongu = requestAnimationFrame(olc);
  } else {
    // Seviye ölçülemeyen tarayıcı: yalnızca azami süre ve elle durdurma.
    konusuldu = true;
    setTimeout(durdur, azamiMs);
  }

  kaydedici.start(250);
  return { bitti, durdur };
}

// ---------- Tarayıcı bildirimi ----------

const SW_YOLU = `${process.env.PUBLIC_URL || ''}/asistan-sw.js`;

export const bildirimDestekleniyor = () =>
  typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export const iPhoneMu = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

// iPhone'da bildirim YALNIZCA ana ekrana eklenmiş uygulamada çalışır (iOS 16.4+).
export const anaEkrandaMi = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;

function anahtarDonustur(base64) {
  const dolgu = '='.repeat((4 - (base64.length % 4)) % 4);
  const ham = atob((base64 + dolgu).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...ham].map(c => c.charCodeAt(0)));
}

export async function kayitliServisCalisani() {
  if (!bildirimDestekleniyor()) return null;
  return navigator.serviceWorker.register(SW_YOLU);
}

// Bu cihazın mevcut aboneliği (yoksa null).
export async function mevcutAbonelik() {
  const kayit = await kayitliServisCalisani();
  return kayit ? kayit.pushManager.getSubscription() : null;
}

// İzin ister ve abone olur. acikAnahtar: sunucunun VAPID açık anahtarı.
export async function aboneOl(acikAnahtar) {
  const izin = await Notification.requestPermission();
  if (izin !== 'granted') throw new Error('Bildirim izni verilmedi. Tarayıcı ayarlarından bu siteye bildirim izni verin.');

  const kayit = await kayitliServisCalisani();
  await navigator.serviceWorker.ready;
  let abonelik = await kayit.pushManager.getSubscription();
  if (!abonelik) {
    abonelik = await kayit.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: anahtarDonustur(acikAnahtar),
    });
  }
  const j = abonelik.toJSON();
  return { endpoint: j.endpoint, p256dh: j.keys.p256dh, auth: j.keys.auth };
}

export async function aboneliktenCik() {
  const abonelik = await mevcutAbonelik();
  if (!abonelik) return null;
  const endpoint = abonelik.endpoint;
  await abonelik.unsubscribe();
  return endpoint;
}
